import React, {useEffect, useState, Fragment} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {
  Container, 
  Paper, 
  Grid, 
  IconButton,
  Alert,
  AlertTitle,
  Dialog,
  DialogActions,
  DialogContent
} from '@mui/material';
import { makeStyles } from '@mui/styles';


import logo from 'assets/logo.png';
import Form1 from './Form_1';
import Form2 from './Form_2';
import Form3 from './Form_3';
import Form4 from './Form_4';
import Form5 from './Form_5';
import Form6 from './Form_6';
import Form7 from './Form_7';
import Success from './Success';
import TenantInfo from './TenantInfo';
import { getLandlordAction, setErrorAction } from 'redux/actions/getFormActions';

const useStyles = makeStyles((theme) => ({
  logo: {
      width: 250,
      height: 80
    },
}));

const steps = ['step1', 'step2', 'step3', 'step4', 'step5', 'step6', 'step7', 'step8',];

export default function ClaimForm() {
  const formData = useSelector(state => state.formData);
  const dispatch = useDispatch();

  const [activeStep, setActiveStep] = useState(0);
  const classes = useStyles();
  const isStepOptional = (step) => {
    return step === 1;
  };

  useEffect(() => {
    dispatch(getLandlordAction());
  }, [])

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleStepLabel = (index) => {
    if (index < activeStep) {
      setActiveStep(index);
    }
  }

  return (
    <Container >
      <Grid container justifyContent='center' alignItems="center">
        <Grid item md={activeStep === 6 ? 11 : 6} sx={{my: 4}}>
          <Paper sx={{bgcolor: '#f9f9f9'}}>
            <Grid container justifyContent="center" direction="column" padding={{xs:0, sm: 4}}>
                <Grid container justifyContent={'center'} sx={{my: 3}}>
                  <img src={logo} className={classes.logo}/>
                </Grid>
                <Typography variant="h4" color="primary" sx={{ mb: 5, textAlign: 'center' }}>
                  Claim Information
                </Typography>
                <Box  sx={{ width: '100%' }} >
                  <Stepper activeStep={activeStep}>
                    {steps.map((label, index) => {
                      const stepProps = {};
                      const labelProps = {};
                      return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps} onClick={() => handleStepLabel(index)}></StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                    {activeStep === steps.length ? (
                      <Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                          All steps completed - you&apos;re finished
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                          <Box sx={{ flex: '1 1 auto' }} />
                          <Button onClick={handleReset}>Reset</Button>
                        </Box>
                      </Fragment>
                    ) : (
                      <Fragment>
                        {activeStep === 0 && <Form1 handleNext={handleNext} handleBack={handleBack} />}
                        {activeStep === 1 && <Form2 handleNext={handleNext} handleBack={handleBack} />}
                        {activeStep === 2 && <Form3 handleNext={handleNext} handleBack={handleBack} />}
                        {activeStep === 3 && <Form4 handleNext={handleNext} handleBack={handleBack} />}
                        {activeStep === 4 && <Form5 handleNext={handleNext} handleBack={handleBack} />}
                        {activeStep === 5 && <Form6 handleNext={handleNext} handleBack={handleBack} />}
                        {activeStep === 6 && <Form7 handleNext={handleNext} handleBack={handleBack} handleStep={(value) => setActiveStep(value)}/>}
                        {activeStep === 7 && <Success handleBack={() => setActiveStep(0)} />}
                      </Fragment>
                    )}
                </Box>
                <Dialog
                    open={!!formData.error}
                    onClose={() => dispatch(setErrorAction(null))}
                  >
                    <DialogContent>
                      <Alert
                            severity="error"
                        >
                            <AlertTitle>Error</AlertTitle>
                            {formData.error}
                      </Alert>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => dispatch(setErrorAction(null))} autoFocus>
                            <Typography color="Primary">
                                Ok
                            </Typography>
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
